import { Link } from 'react-router-dom';
import { motion, useReducedMotion, type MotionValue } from 'framer-motion';
import { ProductImage } from '../../ui/ProductImage';
import { ease } from '../../core/format/motion';
import type { Product } from '../../core/types/catalog';
type Props = {
  products: Product[];
  y: MotionValue<number> | undefined;
  delay: number;
};

/**
 * De voorlaag van de hero: losse producten die over de rand van het portret zweven. Ze bewegen
 * bij scrollen het snelst (omhoog), waardoor het portret erachter lijkt te liggen. Gewone links
 * met de productnaam; vaste afmetingen, zodat er niets verspringt.
 *
 * Computer: één over de linkerrand (half in de tekstkolom), één rechtsboven in het beeld.
 * Telefoon: alleen de eerste, kleiner, over de onderrand van het portret.
 */
const PLACES = ['right-4 -bottom-6 w-[5.5rem] sm:right-8 sm:w-28 lg:-left-14 lg:bottom-auto lg:right-auto lg:top-[34%] lg:w-36', 'hidden lg:block lg:right-12 lg:top-[16%] lg:w-32 xl:right-16'];
export function HeroFloatingProducts({
  products,
  y,
  delay
}: Props) {
  const reduce = useReducedMotion();
  if (products.length === 0) return null;
  return <motion.ul style={y ? {
    y
  } : undefined} aria-label="Uitgelicht" className="pointer-events-none absolute inset-0 z-raised" data-id="element-7346" data-mp="1a56uzi0iad89">
      {products.map((p, i) => <motion.li key={p.id} className={`pointer-events-auto absolute ${PLACES[i] ?? 'hidden'}`} initial={reduce ? false : {
      opacity: 0,
      y: 14,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.3,
      delay: delay + i * 0.06,
      ease
    }} data-id="element-7347" data-mp="1jv04mdh38i9v" data-mpi={i}>
          <Link to={`/webshop/${p.id}`} className="group block bg-shell p-2 shadow-float transition-transform duration-150 ease-soft hover:-translate-y-1 focus-visible:-translate-y-1" data-id="element-7348" data-mp="1xvjdtnxahudm">
            <ProductImage src={p.image} alt="" width={144} className="aspect-[4/5] w-full p-1.5" data-id="element-7349" data-mp="3i1kfka7e3ao" />
            <span className="mt-1.5 hidden px-1 pb-0.5 text-[12px] leading-snug text-ink sm:line-clamp-2" data-id="element-7350" data-mp="8fjwvknfj0nf">{p.name}</span>
            <span className="sr-only sm:hidden" data-id="element-7351" data-mp="1bs23hbndspi3">{p.name}</span>
          </Link>
        </motion.li>)}
    </motion.ul>;
}